export default {"src":"/_next/static/media/comparePlayer.5bb65fa7.svg","height":14,"width":13};